import { render } from "./CommunityLearningIndex.vue?vue&type=template&id=131672a3"
import script from "./CommunityLearningIndex.vue?vue&type=script&lang=js"
export * from "./CommunityLearningIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__